/**
 * Decode HTML entities in a string
 *
 * @param {string} html String with HTML entities
 * @returns {string} Decoded string
 */
export function decodeHTMLEntities(html) {
	const txt = document.createElement('textarea');
	txt.innerHTML = html;
	return txt.value;
}

/**
 * Decode HTML entities twice to handle double-encoded payloads like "&amp;#8217;".
 *
 * @param {string} html String with potentially double-encoded entities
 * @returns {string} Decoded string
 */
export function decodeHTMLEntitiesDeep(html) {
	return decodeHTMLEntities(decodeHTMLEntities(html));
}

/**
 * Get WooCommerce placeholder image URL
 *
 * @returns {string} Placeholder image URL
 */
export function getWooCommercePlaceholderImage() {
	const placeholderMeta = document.querySelector('meta[name="wc-placeholder-image"]');
	if (placeholderMeta) {
		return placeholderMeta.getAttribute('content');
	}

	// Fallback to a generic placeholder if meta tag not found
	return '';
}

/**
 * Normalize a WooCommerce image URL.
 *
 * @param {string} imageUrl WooCommerce-provided image URL (thumbnail preferred)
 * @returns {string} Normalized image URL
 */
export function getThumbnailImageUrl(imageUrl) {
	if (!imageUrl) {
		return getWooCommercePlaceholderImage();
	}

	const url = new URL(imageUrl);
	// Normalize double slashes in pathname (e.g. //wp-content/ → /wp-content/)
	url.pathname = url.pathname.replace(/\/\/+/g, '/');
	return url.toString();
}
